import React from 'react'
import OrderDetailsIndex from '../../components/order/OrderDetails'

const OrderDetailsPage = () => {
  return (
    <OrderDetailsIndex/>
  )
}

export default OrderDetailsPage
